import { writable } from 'svelte/store';

let work = writable([
  {
    title: "BaseX Corp",
    descEN: "Base X Corporation is a program that provides companies with a large team of experts who cover all digital needs from conception to full implementation.",
    descFR: "BaseX Corp est un programme qui met à la disposition des entreprises une équipe d'experts couvrant l'ensemble des besoins digitaux de la conception à la réalisation.",
    role: "Full-Stack Developer",
    year: "2025",
    // url: "https://basexcorp.com",
    url: "https://basex.pages.dev",
    inProgress: false,
    isPrivate: false
  },
  {
    title: "SPAfrica",
    descEN: "SPAfrica is an electronic security company based in DR Congo, providing industrial, commercial and residential security to businesses for nearly a decade.",
    descFR: "SPAfrica est une société de sécurité electronique, assurant la sécurité industrielle, commerciale et résidentielle aux entreprises depuis près d'une decenie.",
    role: "Full-Stack Developer",
    year: "2025",
    url: "https://spafrica.net",
    inProgress: false,
    isPrivate: false
  },
  {
    title: "VoxDei TV",
    descEN: "VoxDei TV is a destination for Christian worship, teaching, family content, and more. It provides live broadcasts to stay connected in real time.",
    descFR: "VoxDei TV est une destination dédiée au culte chrétien, à l'enseignement, aux programmes familiaux et plus. Elle diffuse du contenu en direct 24h/24",
    role: "Full-Stack Developer",
    year: "2025",
    url: "http://voxdeitv.com",
    inProgress: false,
    isPrivate: false
  },
  {
    title: "Nourane Décor",
    descEN: "Localisé en RD Congo, Nourane Décor™ est une entreprise qui œuvre dans la décoration des évènements ainsi que la déco d'interieur.",
    descFR: "Located in Lubumbashi, DR Congo. Nourane Décor™ is a agency that works in event decoration as well as interior decoration.",
    role: "Full-Stack Developer",
    year: "2024",
    url: "https://nourane.net",
    inProgress: false,
    isPrivate: false
  },
  {
    title: "Future Jobs",
    descEN: "Atlas of emerging jobs in the Food & Beverage Manufacturing Industry. It aims at visually providing details about new & exciting jobs and skills of the future.",
    descFR: "Atlas des emplois émergents dans l'industrie de la fabrication d'aliments & boissons. Il vise à fournir visuellement des infos sur les emplois et compétences du futur.",
    role: "Front-End Developer",
    year: "2023",
    url: "https://atlas-jobs.pages.dev",
    inProgress: false,
    isPrivate: false
  },
  {
    title: "Academie du Potentiel",
    descEN: "Academy of potential is an online learning platform, part of the M.A.N program, where a wide variety of paid courses and conferences are availed to the public.",
    descFR: "L'Académie du potentiel est une plate-forme d'apprentissage en ligne, où une grande variété de cours et conférences payantes sont disponibles pour le grand public.",
    role: "Full-Stack Developer",
    year: "2023",
    url: "https://academiepotentiel.com",
    inProgress: false,
    isPrivate: false
  },
  {
    title: "TymApp",
    descEN: "TymApp is an online platform that allows its users to either buy or sell fashion. It's the go-to online marketplace to sell and buy used and brand-new clothes.",
    descFR: "Plateforme qui offre à la possibilité d'acheter ou de vendre des vêtements. C'est le marché en ligne incontournable pour vendre et acheter des vêtements usés et neufs.",
    role: "Full-Stack Web Developer",
    year: "2022",
    url: "https://tymapp.pages.dev",
    inProgress: false,
    isPrivate: false
  },
  {
    title: "TEDx Makomeno",
    descEN: "TEDx events are local gatherings where live TED-like talks and performances are shared with the community. TEDx Makomeno is held in Lubumbashi DR Congo.",
    descFR: "TEDx sont des rassemblements locaux où des conférences de type TED sont partagées avec la communauté. TEDx Makomeno se tient tenu à Lubumbashi RD Congo.",
    role: "Full-Stack Engineer",
    year: "2022",
    url: "https://tedxmakomeno.pages.dev",
    inProgress: false,
    isPrivate: false
  },
  {
    title: "Paul Z. Minu",
    descEN: "Paul Zozo Minu is a speaker and writer, pastor at Rehoboth Church International. Graduated in Mechanical Engineering at Eastern Mediterranean University.",
    descFR: "Paul Zozo Minu est un conférencier et écrivain, Pasteur à Rehoboth Church International. Diplômé en Genie Mécanique à Eastern Mediterranean University.",
    role: "Full-Stack Developer",
    year: "2022",
    url: "https://pzozominu.com",
    inProgress: false,
    isPrivate: false
  },
  {
    title: "Fabi CC System",
    descEN: "A Cloud-based system made in partnership with NiS for a sportswear company. The features include stock control, manufacture process management, ordering and more.",
    descFR: "Réalisé en partenariat avec NiS pour Fabi Sportwears. Ses fonctionnalités incluent la gestion des stocks, commandes, processus de manufacturation, et bien plus.",
    role: "Full-Stack Engineer - UI/UX Designer",
    year: "2022",
    url: "",
    inProgress: false,
    isPrivate: true
  },
  {
    title: "J.I.K's MasterClass",
    descEN: "J.I.K's Masterclass is a mini learning platform with payment integrated. It features to its audience a curated list of video content on how to become better writers.",
    descFR: "J.I.K's Masterclass est une mini plate-forme d'apprentissage mettant en vente une liste organisée de matériaux sur comment devenir un meilleur écrivain.",
    role: "Full-Stack Web Developer",
    year: "2022",
    url: "https://masterclass.jonathanisaack.com",
    inProgress: false,
    isPrivate: false
  },
  {
    title: "Jonathan Isaac K",
    descEN: "Jonathan Isaac Kahambo is a thinker, life coach, mentor, entrepreneur, speaker, author, composer and writer of Congolese nationality (DR Congo).",
    descFR: "Jonathan Isaac Kahambo est un penseur, coach de vie, mentor, entrepreneur, conférencier, auteur, compositeur et écrivain de la nationalité congolaise.",
    role: "Full-Stack Engineer",
    year: "2021",
    url: "https://jonathanisaack.com",
    inProgress: false,
    isPrivate: false
  },
  {
    title: "25Frames Studio",
    descEN: "Animation and VFX studio. Created by two young cameroonians in 2017, 25Frames Studio aims to see the animated film develop nationally and continentally.",
    descFR: "Studio d'animation et effets spéciaux. Crée par deux camerounais en 2017, 25Frames souhaite voir le film d’animation se developer sur l'etendue nationale & continentale.",
    role: "Front-End Web Developer",
    year: "2021",
    url: "https://25frames.pages.dev",
    inProgress: false,
    isPrivate: false
  },
  {
    title: "SA'Connect",
    descEN: "SA'Connect is an online platform that connects a wide range of providers of goods and services to our user base in need through an intuitive interface.",
    descFR: "SA'Connect est une plateforme en ligne qui mets en relation une large gamme de pourvoyeurs des biens et services à notre base d'utilisateur dans le besoin.",
    role: "Full-Stack Engineer",
    year: "2021",
    url: "https://saconnect.pages.dev",
    inProgress: true,
    isPrivate: false
  },
  {
    title: "Global Capital S.A.R.L",
    descEN: "It is a company specializing in e-commerce, the buying and selling of corporate shares, and the exchange of currencies listed on the world's stock exchange.",
    descFR: "Il s'agit d'une entreprise spécialisée dans le commerce électronique, l'achat et la vente de titres et actions d'entreprise et l'échange de devises côté en bourse.",
    role: "Front-End Web Developer",
    year: "2021",
    url: "https://globalcapital.pages.dev",
    inProgress: true,
    isPrivate: false
  },
  {
    title: "BNTV Music",
    descEN: "BNTV Music is an amazing program that is part of the Black Network Television aiming at featuring on the world's stage some of the finest african talents in music.",
    descFR: "BNTV Music est un programme special qui fait partie de Black Network Television visant à présenter sur la scène mondiale certains des meilleurs talents africains de la musique.",
    role: "Full-Stack Web Developer",
    year: "2021",
    url: "https://bntv-africa-music.pages.dev",
    inProgress: false,
    isPrivate: false
  },
  {
    title: "BNTV Africa",
    descEN: "A global broadcasting network meeting the challenges of change in the social structure of Black society. BNTV unveils to the world the true magnitude of Black culture.",
    descFR: "Un réseau de diffusion mondial répondant aux défis du changement de la structure sociale de la société noire. BNTV dévoile au monde la véritable ampleur de la culture noire.",
    role: "Full-Stack Web Developer",
    year: "2021",
    url: "https://bntv-africa.pages.dev",
    inProgress: false,
    isPrivate: false
  },
  {
    title: "Given Foundation",
    descEN: "A Non-profit association whose mission is to support the education of orphaned children, the empowerment and social reintegration of elderly widows in DRC.",
    descFR: "ONG ayant pour mission de soutenir la scolarisation des enfants orphelins, l’autonomisation et la réinsertion sociale des veuves du 3ème âge en RD Congo.",
    role: "Full-Stack Engineer",
    year: "2021",
    url: "https://fondationgiven.com",
    inProgress: false,
    isPrivate: false
  },
  {
    title: "Restauration Des Familles",
    descEN: "In this project, I was tasked to build a website for *Restauration des Familles*, where books and audio content are available both for free and for sale.",
    descFR: "Dans ce projet, j'ai été chargé de créer un site pour *Restauration des Familles*, où des livres et du contenu audio sont disponibles gratuitement et à la vente.",
    role: "Full-Stack Engineer",
    year: "2020",
    url: "https://restaurationdesfamilles.pages.dev",
    inProgress: false,
    isPrivate: false
  },
  {
    title: "Project Semeron",
    descEN: "Project Semeron is a Progressive Web Application made for a magazine  that aims at sending motivational messages to its base of users every morning.",
    descFR: "Semeron est une Application Web Progressive conçue pour un magazine qui vise à envoyer chaque matin des messages de motivation à sa base d'utilisateurs.",
    role: "Full-Stack Engineer",
    year: "2020",
    url: "https://semeron.app",
    inProgress: false,
    isPrivate: false
  },
  {
    title: "Soft UI Library",
    descEN: "Soft UI Library is an open-source collection of UI elements implementing a neumorphic design pattern with a light mode and dark mode toggle.",
    descFR: "Une collection d'éléments d'interface utilisateur mettant en œuvre un modèle de conception neumorphique avec basculement du mode clair / sombre.",
    role: "Front-End Developer",
    year: "2020",
    url: "https://katendeglory.github.io/soft-ui-library",
    inProgress: false,
    isPrivate: false
  },
  {
    title: "Eswatini Loans",
    descEN: "A bridge of interaction between loan-seekers and loan-providers. The Application was the place where Loan would be treated by the appropriate banks.",
    descFR: "Un pont d'interaction entre les demandeurs de prêts et les fournisseurs de prêts bancaires. L'application était le lieu où le prêt serait traité par les banques.",
    role: "Desktop App Engineer",
    year: "2020",
    url: "",
    inProgress: false,
    isPrivate: true
  },
].map((project, num) => {
  // console.log(`💡 Project #${num + 1}`);
  return ({ id: num + 1, ...project })
}));

export default work;